import React, { FC, useState } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { Box } from 'transfix-ui/core'
import { TextField } from 'transfix-ui'

interface ISearchLaneIdProps {
  onSubmit: (val?: number) => void
}

/**
 * Text input field to search by Shipper City Lane ID
 */
const SearchLaneId: FC<ISearchLaneIdProps> = ({ onSubmit: onSubmitProp }) => {
  const [laneId, setLaneId] = useState<string | undefined>(undefined)

  const onSearchClickHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    event.preventDefault()
    const value = Number(laneId)
    const shipperCityLaneId = value > 0 ? value : undefined
    onSubmitProp(shipperCityLaneId)
  }

  return (
    <Box display='flex' alignItems='center'>
      <Box width='150px' mr={1}>
        <TextField
          name='laneId'
          placeholder='Lane ID'
          type='number'
          clearable
          onClearCallback={() => onSubmitProp(undefined)}
          value={laneId}
          onChange={ev => setLaneId(ev.target.value)}
        />
      </Box>
      <Button size='small' color='primary' onClick={onSearchClickHandler}>
        Search
      </Button>
    </Box>
  )
}

export default SearchLaneId
